import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getDemandToken = async (id) => {
  let response;
  try {
    response = await apiWrapper(
      "GET",
      `/demand-token?master_bookingservice_id=${id}`
    );
    console.log("getDemandToken response.data :>> ", response.data);
    store.commit("demand/setDemandToken", response.data);
  } catch (err) {
    console.log('ERROR"" getDemandToken():', err);
    throw err;
  }
};
